goog.provide("shadow.js.shim.module$src$svg$files_folders$file_text_svg");
goog.provide("module$shadow_js_shim_module$src$svg$files_folders$file_text_svg");
shadow.js.shim.module$src$svg$files_folders$file_text_svg = shadow.js.nativeProvides["src/svg/files_folders/file-text.svg"] = shadow$bridge("src/svg/files_folders/file-text.svg");
module$shadow_js_shim_module$src$svg$files_folders$file_text_svg.default = shadow.js.shim.module$src$svg$files_folders$file_text_svg;
